const marqueeItems = [
  "Free for a limited time",
  "Profile verification free",
  "First collaboration free",
  "10+ Global Collaborations Closed This Month!",
  "No Commission",
  "No Profit Share",
];

const renderMarqueeChunk = (suffix: string, hidden = false) => (
  <span className="navbar-marquee-chunk" aria-hidden={hidden}>
    {marqueeItems.map((item) => (
      <span key={`${suffix}-${item}`} className="marquee-seg marquee-seg--ny">
        <strong className="marquee-text-white">{item}</strong>
        <span className="marquee-sep" aria-hidden="true">
          ·
        </span>
      </span>
    ))}
  </span>
);

export default function NavbarMarqueeBand() {
  return (
    <div
      className="navbar-marquee-band"
      role="region"
      aria-label="Limited-time offer: free profile verification, first collaboration, and first cycle"
    >
      <div className="navbar-marquee-mask">
        <div className="navbar-marquee-track">
          {renderMarqueeChunk("primary")}
          {renderMarqueeChunk("duplicate-1", true)}
          {renderMarqueeChunk("duplicate-2", true)}
        </div>
      </div>
    </div>
  );
}
